import { focusRingNoGap } from '../../Themes/base/focusRing';
import { borderColor, borderRadius, borderStyle, borderWidth } from '../../Utilities/utils/Theming';
import { IDummyProps } from './types';

export const InputBaseStyle = ($theme: any, props: IDummyProps, _isFocused: boolean) => {
	return {
		...borderWidth($theme.input.inputBorderWidth),
		...borderColor(props.phantom ? 'transparent' : $theme.colors.inputBorder),
		...borderRadius('var(--epods--border-radius)'),
		...borderStyle('solid'),
		':hover': {
			...borderColor($theme.input.inputHoverBorder),
		},
		alignItems: 'center',
		backgroundColor: 'var(--epods--color-bg-input)',
	};
};

export const InputBaseFontStyle = ($theme: any, props: IDummyProps) => {
	return {
		maxWidth: '100%',
		minWidth: '0',
		...$theme.typography.fontBaseP,
		fontSize: props.size ? `var(--epods--input-${props.size}-font-size)` : 'var(--epods--input-default-font-size)',
		color: 'var(--epods--color-text-primary)',
	};
};

export const InputSpacing = ($theme: any, props: IDummyProps) => {
	return {
		paddingTop: $theme.input.inputPaddingTopBottom,
		paddingBottom: $theme.input.inputPaddingTopBottom,
		paddingLeft: props.iconBefore ? '0' : $theme.input.inputPaddingSide,
	};
};

const InputContainerFocused = ($theme: any, $isFocused: boolean) => {
	return {
		...($isFocused ? focusRingNoGap : {}),
		...borderColor('transparent !important'),
	};
};

const InputContainerError = ($theme: any, $error: boolean) => {
	return {
		...borderColor($error ? $theme.colors.inputBorderError : $theme.colors.inputBorder),
		backgroundColor: $error ? $theme.colors.inputFillError : $theme.colors.inputFill,
	};
};

const InputContainerWarning = ($theme: any, $warning: boolean) => {
	return {
		...borderColor($warning ? $theme.colors.inputBorderWarning : $theme.colors.inputBorder),
		backgroundColor: $warning ? $theme.colors.inputFillWarning : $theme.colors.inputFill,
	};
};

const InputContainerPositive = ($theme: any, $positive: boolean) => {
	return {
		...borderColor($positive ? $theme.colors.inputBorderPositive : $theme.colors.inputBorder),
		backgroundColor: $positive ? $theme.colors.inputFillPositive : $theme.colors.inputFill,
	};
};

const InputReadonlyStyles = ($theme: any, phantom: boolean) => {
	return {
		backgroundColor: $theme.colors.inputFillReadOnly,
		...borderColor(phantom ? 'transparent' : $theme.colors.inputBorderReadonly),
		':hover': {
			backgroundColor: $theme.colors.inputFillReadOnly,
			...borderColor($theme.colors.inputBorder),
		},
	};
};

const InputDisabledStyles = ($theme: any) => {
	return {
		...borderColor($theme.colors.inputBorderDisabled),
		...borderWidth($theme.input.inputBorderWidth),
		backgroundColor: $theme.colors.inputFill,
		color: 'var(--epods--color-text-disabled)',
		':hover': {
			backgroundColor: $theme.colors.inputFill,
		},
	};
};

export const InputEpoCustoms = (
	$theme: any,
	$isFocused: boolean,
	$error: boolean,
	$positive: boolean,
	$warning: boolean,
	props: IDummyProps,
) => {
	const focusCtrl = $isFocused ? InputContainerFocused($theme, $isFocused) : {};
	const errorCtrl = $error ? InputContainerError($theme, $error) : {};
	const positiveCtrl = $positive ? InputContainerPositive($theme, $positive) : {};
	const warningCtrl = $warning ? InputContainerWarning($theme, $warning) : {};
	const readonlyCtrl = props.readOnly && !props.disabled ? InputReadonlyStyles($theme, !!props.phantom) : {};
	const disabledCtrl = props.disabled && !props.readOnly ? InputDisabledStyles($theme) : {};
	const readOnlyColorType =
		props.readOnly && props.disabled ? { backgroundColor: $theme.colors.inputFillReadOnly } : {};

	return {
		...focusCtrl,
		...errorCtrl,
		...positiveCtrl,
		...warningCtrl,
		...readonlyCtrl,
		...disabledCtrl,
		...readOnlyColorType,
	};
};

export const ForceRemoveBorders = {
	//TODO: remove !important
	maxWidth: '100%',
	boxShadow: 'none !important',
	...borderWidth('0 !important'),
};

export const InputDisabledStyle = ($theme: any, props: IDummyProps) => {
	if (props.disabled) {
		return {
			cursor: 'hand',
		};
	}
};

export const InputColorStyle = ($theme: any, props: IDummyProps) => {
	if (props.type === 'color') {
		return {
			height: $theme.input.inputColorHeightP,
			paddingBottom: '0',
			paddingTop: '0',
		};
	}
};

export const IconBeforeInputStyles = ($theme: any) => {
	return {
		paddingLeft: $theme.input.inputPaddingLeftIconBefore,
		paddingRight: $theme.input.inputPaddingRightIconBefore,
		alignItems: 'center',
		display: 'flex',
	};
};

export const IconAfterInputStyles = ($theme: any) => {
	return {
		paddingRight: $theme.input.inputPaddingRightIconAfter,
		alignItems: 'center',
		display: 'flex',
	};
};
